export default __webpack_public_path__ + "static/media/categoria_noi.a73a6c79.svg";